import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { TemplatesManager } from "../../../library-js/templates/TemplatesManager";
import { DomElement, DomElementConstructorType } from "../../../library/ts/html/dom/DomElement";
import { Rokojori } from "../../js/Rokojori";

export class UserApp<DataType,UIRoot>
{
  protected _id:string;
  protected _uiRoot:DomElement<any>;
  get root(){ return this._uiRoot as UIRoot; }

  protected _uiRootType:DomElementConstructorType;

  protected _userData:DataType;
  get data(){ return this._userData;}
  

  constructor( id:string, uiRootType:DomElementConstructorType )
  {
    this._id = id;
    this._uiRootType = uiRootType;
  }

  async canUse():Promise<boolean>
  {
    console.log( "Checking usage: " + this._id );
    
    if ( ! Rokojori.$.userSystem.isLoggedIn )
    {
      console.log( "Not logged in, can't use user app" );
      return Promise.resolve( false );
    }

    return Rokojori.$.userSystem.canUseApp( this._id );
  }

  async start( e:Element ):Promise<boolean>
  {
    let canUse = false;

    console.log( "Starting app: " + this._id );

    try
    {
      canUse = await this.canUse();
    }
    catch( e )
    {
      console.error( e );
    }
    

    if ( ! canUse )
    {
      let infoElement = Rokojori.$.createTemplate( "needs-user" );
      let footerElement = Rokojori.$.createTemplate( "rj-footer-en" );
      HTMLEditor.addAfter( e, infoElement );
      HTMLEditor.addAfter( infoElement, footerElement );
      HTMLEditor.remove( e );

      return Promise.resolve( false );
    }

    this._uiRoot = new ( this._uiRootType as any ) ( e ); 

    await this.loadData();

    return Promise.resolve( true );
  }

  async loadData():Promise<boolean>
  {
    this._userData = null;

    this._userData = await Rokojori.$.userSystem.loadAppData<DataType>( this._id );

    return false; 
  }

  async saveData():Promise<boolean>
  {
    return await Rokojori.$.userSystem.saveAppData<DataType>( this._id, this._userData );
  }

  async deleteTask( taskID:string ):Promise<boolean>
  {
    return await Rokojori.$.userSystem.deleteAppTask( this._id, taskID );
  }
}